<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="收货方" prop="orderPointName" size="small">
            <el-input
              clearable
              v-model="formData.orderPointName"
              placeholder="请输入收货方"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="choiceToAndFrom()"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="目的地" size="small" prop="provinceCode">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
              size="small"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="linePointAddress" size="small">
            <el-input
              size="small"
              placeholder="请输入详细地址"
              v-model="formData.linePointAddress"
            >
              <el-button
                slot="append"
                size="small"
                icon="el-icon-map-location"
                @click="openCoordPickerDialog()"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="联系人" prop="contactName" size="small">
            <el-input
              clearable
              v-model="formData.contactName"
              placeholder="请输入联系人"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="手机号" prop="contactMobile" size="small">
            <el-input
              clearable
              v-model="formData.contactMobile"
              placeholder="请输入手机号"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="固定电话" prop="contactPhone" size="small">
            <el-input
              clearable
              v-model="formData.contactPhone"
              placeholder="请输入固定电话"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系人Email" prop="contactEmail" size="small">
            <el-input
              clearable
              v-model="formData.contactEmail"
              placeholder="请输入联系人Email"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            label="收货电子围栏半径（米）"
            prop="electronicFence"
            size="small"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.electronicFence"
              :step="1"
              :precision="0"
              :min="0"
              controls-position="right"
              placeholder="请选择围栏半径"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否需要卸货" prop="orderPickType" size="small">
            <el-select
              style="width:100%"
              v-model="formData.orderPickType"
              size="small"
            >
              <el-option label="否" value=""> </el-option>
              <el-option label="是" value="X"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark" size="small">
            <el-input
              v-model="formData.remark"
              placeholder="请输入备注信息"
              type="text"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <vxe-modal
      ref="choiceToAndFrom"
      v-model="dialogOption.dialogVisible"
      :title="dialogOption.title"
      width="1050"
      height="550"
      destroy-on-close
      type="modal"
      resize
    >
      <master-point
        :formData="choiceFormData"
        @close="close"
        @choiceOk="choiceOk"
      />
    </vxe-modal>

    <coord-picker-dialog
      v-if="coordPickerDialogVisible"
      :visible.sync="coordPickerDialogVisible"
      :address.sync="formData.linePointAddress"
      :longitude.sync="formData.linePointLongitude"
      :latitude.sync="formData.linePointLatitude"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import MasterPoint from './table/master-point'
export default {
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MasterPoint,
  },
  data() {
    return {
      custCode: '',
      regionShow: false,
      coordPickerDialogVisible: false,
      openCoordPickerDialogOptions: {
        visible: false,
      },
      backDialogVisible: false,
      dialogOption: {
        title: '',
        dialogVisible: false,
      },
      choiceFormData: {pointTypeList: ['X', 'R']},
      formData: {
        orderCode: this.code,
        orderPointType: 'R',
        sortOrder: 2,
        orderPointName: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        linePointAddress: '',
        linePointLongitude: '',
        linePointLatitude: '',
        contactName: '',
        contactMobile: '',
        contactPhone: '',
        contactEmail: '',
        electronicFence: '',
        dialogVisible: false,
      },
      rules: {
        orderPointName: [
          {required: true, message: '请输入收货方', trigger: 'change'},
        ],
        provinceCode: [
          {required: true, message: '请选择目的地', trigger: 'change'},
        ],
        linePointAddress: [
          {required: true, message: '请输入详细地址', trigger: 'change'},
        ],
      },
    }
  },
  computed: {
    matchData() {
      return {
        provinceCode: this.formData.provinceCode,
        cityCode: this.formData.cityCode,
        districtCode: this.formData.districtCode,
        orderPickType: this.formData.orderPickType,
        linePointAddress: this.formData.linePointAddress,
      }
    },
  },
  watch: {
    matchData: {
      deep: true,
      handler() {
        this.$eventBus.$emit('resetBuilderContract')
      },
    },
  },
  mounted() {
    let _this = this
    this.regionShow = true
    this.$eventBus.$on('splitCustCodeChange', function(val) {
      _this.load(val)
    })
  },
  methods: {
    load(val) {
      this.custCode = val
    },
    reset() {
      this.formData = {}
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
    },
    async getReceivingData() {
      const result = await validate.formValidate([this.$refs.formData])
      const linePointLongitude = this.formData.linePointLongitude
      if (!result) {
        this.$message.error('收货方，有必输字段未填写，请检查')
        return
      }
      if (!linePointLongitude) {
        this.$message.error('收货方，地址经纬度未标记，请检查')
        return
      }
      return this.formData
    },
    openCoordPickerDialog() {
      this.coordPickerDialogVisible = true
    },
    async choiceToAndFrom() {
      this.dialogOption.title = '选择客户门点'
      this.choiceFormData.keyword = this.formData.orderPointName

      if (!this.custCode) {
        this.$alert('未选择客户，请选择客户后再进行匹配！', '提示信息', {})
        return
      }
      this.choiceFormData.custCode = this.custCode
    
      this.dialogOption.dialogVisible = true
    },
    choiceOk(data) {
      // console.log(JSON.stringify(data))
      this.formData.orderPointName = data.pointName
      this.formData.provinceCode = data.provinceCode
      this.formData.provinceName = data.provinceName
      this.formData.cityCode = data.cityCode
      this.formData.cityName = data.cityName
      this.formData.districtCode = data.districtCode
      this.formData.districtName = data.districtName
      this.formData.linePointAddress = data.detailAddress
      this.formData.linePointLongitude = data.pointLongitude
      this.formData.linePointLatitude = data.pointLatitude
      this.formData.contactName = data.contactName
      this.formData.contactMobile = data.contactMobile
      this.formData.contactPhone = data.contactPhone
      this.formData.contactEmail = data.contactEmail
      this.formData.electronicFence = data.pointFence
      this.dialogOption.dialogVisible = false
    },
    close() {
      this.dialogOption.dialogVisible = false
    },
  },
}
</script>
